import React from 'react';
import { ERouteLinks } from 'models/route';
import { useTranslations } from 'hooks/useTranslations';
import { usePermission } from 'hooks/usePermission';
import { EPermission } from 'models/permissions';
import { EIconTypes } from 'constants/Icons';
import ElementsComponent, { IElements } from './elementsComponent';

const UsersRoles = () => {
  const { t } = useTranslations();
  const { hasPermissions } = usePermission();
  const elements: IElements[] = [];
  if (hasPermissions([EPermission.MANAGE_USERS])) {
    elements.push({ url: ERouteLinks.Users, title: t('users.header') });
  }
  if (hasPermissions([EPermission.MANAGE_ROLES])) {
    elements.push({ url: ERouteLinks.Roles, title: t('roles.header') });
  }

  return (
    <ElementsComponent
      title={`${t('users.header')} & ${t('roles.header')}`}
      iconType={EIconTypes.usersAndRoles}
      elements={elements}
    />
  );
};

export default UsersRoles;
